import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
  ValueSansProvider,
} from '@angular/core';
import type { ApiEndpoints } from '../api-endpoints';

export const API_ENDPOINTS = new InjectionToken('API_ENDPOINTS', {
  providedIn: 'root',
  factory: () => ({}),
});

export interface ApiEndpointsUseValue extends ValueSansProvider {
  useValue: ApiEndpoints;
}

export interface ApiEndpointsUseClass extends ClassSansProvider {
  useClass: Type<ApiEndpoints>;
}

export interface ApiEndpointsUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => ApiEndpoints;
}

export type ApiEndpointsProvider =
  | ApiEndpointsUseValue
  | ApiEndpointsUseFactory
  | ApiEndpointsUseClass;

export type ApiEndpointsConfig = {
  endpoints?: ApiEndpointsUseValue;
};

export function provideApiEndpoints(config: ApiEndpointsConfig) {
  return [
    {
      provide: API_ENDPOINTS,
      multi: true,
      ...config.endpoints,
    },
  ];
}
